<template>
  <div>
    <span class="titleslight--text">{{sTitulo}}</span>
    <v-data-table
      :headers="oDataTable.headers"
      :items="oDataTable.desserts"
      class="elevation-1 mt-1"
      :height="tableHeight"
      hide-default-footer
      fixed-header
    >
    <template v-slot:[`item.grupoimpacto`]="{ item }">
      <v-col cols="12"  v-if="(item.idGrupoimpacto[0]==0)">
        <v-autocomplete
          v-model="nIdGrupoImpacto"
          :items="aGruposImpacto"
          @change="onSeleccionarGrupoImpacto(item,nIdGrupoImpacto)"
          item-text="texto"
          height="10px"
          dense
          item-value="id"
          outlined
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" v-else>
        {{item.grupoimpacto}}
      </v-col>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-icon v-if="item.Borrable" small @click="onDeleteItem(item)" color="red" >
        mdi-delete
      </v-icon>
    </template>
    
    </v-data-table>
  </div>
</template>
<script>
export default {
  name:'FormTabla',
  props: {
    titulo: {
      type: String,
      default:''
    },

    /* estructura base 
      oDataTable:{
        headers: [
          { text: 'Riesgo', value: 'riesgo',},
          { text: 'Grupo de impacto', value: 'grupoimpacto' },
        ],
        desserts: [
          { riesgo: 'Hurto', grupoimpacto: 'Personas'},
        ]
      },
    */  
    oDataTable: {
      type: Object,
      default: () => {}
    },
    tableHeight: {
      type:String,
      default:'200px',
    },
    bDelete : {               // activa el botón de eliminar el elemento que se indique.
      type: Boolean,
      default: false
    },
    sTitulo:{
      type: String,
      default: ''
    },
    aGruposImpacto:{
      type: Array,
      default: () => []
    }

  },
  mounted () {
    // valido si esta activo el bDelete para add esa seccion a la tabla.
    if(this.bDelete) {
      if(this.oDataTable.headers.find(elemento => elemento.value ===  'actions') === undefined ){
        this.oDataTable.headers.push({ text: 'Acciones', value: 'actions' })
      }
    }

  },
  data() {
    return {
      nIdGrupoImpacto:{}
    }
  },
  methods: {
    onDeleteItem(item) {
      // busco el objeto que llega dentro del arreglo que tengo y emito el index de cual se borro,
      const auxIndexEliminar = this.oDataTable.desserts.findIndex(elemento => (elemento.idRiesgo === item.idRiesgo && elemento.idGrupoimpacto === elemento.idGrupoimpacto ))
      this.oDataTable.desserts.splice(auxIndexEliminar,1)
    },
    onSeleccionarGrupoImpacto(item,idGrupoImpacto){
      this.$emit('onCambio',{item:item,idGrupoImpacto:idGrupoImpacto})
    }
  },
}
</script>
<style lang="scss" scoped>

</style>